import Router from "next/router";
import Script from "next/script";

import Meta from "../components/Meta";
import { CmsProvider } from "../hooks/useCMS";
import "../styles/globals.css";

Router.events.on("routeChangeComplete", () => window.analytics.page());
Router.events.on("hashChangeComplete", (url) => window.analytics.page(url));

function MyApp({ Component, pageProps }) {
  return (
    <>
      <Meta />
      <Script
        id="google-analytics-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          
          gtag('config', 'G-BVZMTS0T7Y');
        `,
        }}
      />
      <Script
        id="google-optimize"
        strategy="afterInteractive"
        src="https://www.googleoptimize.com/optimize.js?id=OPT-5XHK39J"
      />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        src="https://www.googletagmanager.com/gtag/js?id=UA-1609839-2"
      />
      <Script
        id="segment-script"
        dangerouslySetInnerHTML={{
          __html: `!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){var t=Array.prototype.slice.call(arguments);t.unshift(e);analytics.push(t);return analytics}};for(var e=0;e<analytics.methods.length;e++){var key=analytics.methods[e];analytics[key]=analytics.factory(key)}analytics.load=function(key,e){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=e};analytics._writeKey="B1j4olldv6PWoHDEUY3Z5kmCmDpijxVg";;analytics.SNIPPET_VERSION="4.15.3";
        analytics.load("${process.env.NEXT_PUBLIC_SEGMENT_WRITE_KEY}");
        analytics.page();
        analytics.track("Visitor")
        }}();`,
        }}
      />
      <CmsProvider>
        <Component {...pageProps} />
      </CmsProvider>
    </>
  );
}

export default MyApp;
